import { lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';

const AdminLogin = lazy(() => import('./AdminLogin'));
const AdminChangePassword = lazy(() => import('./AdminAuth').then(m => ({ default: m.AdminChangePassword })));
const AdminResetWithToken = lazy(() => import('./AdminAuth').then(m => ({ default: m.AdminResetWithToken })));
const AdminLayout = lazy(() => import('./AdminLayout'));
const AdminDashboard = lazy(() => import('./AdminPages').then(m => ({ default: m.AdminDashboard })));
const AdminUsersList = lazy(() => import('./AdminPages').then(m => ({ default: m.AdminUsersList })));
const AdminOrganisations = lazy(() => import('./AdminPages').then(m => ({ default: m.AdminOrganisations })));
const AdminOrgDetail = lazy(() => import('./AdminOrgComponents').then(m => ({ default: m.AdminOrgDetail })));
const AdminCodes = lazy(() => import('./AdminCodes'));
const AdminAdminUsers = lazy(() => import('./AdminAdminUsers'));
const AdminAnalytics = lazy(() => import('./AdminAnalytics'));
const ProductAdminAuditLogs = lazy(() => import('./ProductAdminAuditLogs'));
const AdminUserDetail = lazy(() => import('./AdminUserDetail').then(m => ({ default: m.AdminUserDetail })));
const P150NormAdmin = lazy(() => import('../P150NormAdmin'));

const createProductAdminRoutes = (productKey, productName, accentColor) => {
  return (
    <>
      <Route path={`/${productKey}-admin/login`} element={<AdminLogin productKey={productKey} productName={productName} accentColor={accentColor} />} />
      <Route path={`/${productKey}-admin/change-password`} element={<AdminChangePassword productKey={productKey} productName={productName} accentColor={accentColor} />} />
      <Route path={`/${productKey}-admin/reset-password`} element={<AdminResetWithToken productKey={productKey} productName={productName} accentColor={accentColor} />} />
      <Route path={`/${productKey}-admin`} element={<AdminLayout productKey={productKey} productName={productName} accentColor={accentColor} />}>
        <Route index element={<Navigate to={`/${productKey}-admin/dashboard`} replace />} />
        <Route path="dashboard" element={<AdminDashboard productKey={productKey} productName={productName} accentColor={accentColor} />} />
        <Route path="users" element={<AdminUsersList productKey={productKey} accentColor={accentColor} />} />
        <Route path="users/:userId" element={<AdminUserDetail productKey={productKey} accentColor={accentColor} />} />
        <Route path="organisations" element={<AdminOrganisations productKey={productKey} accentColor={accentColor} />} />
        <Route path="organisations/:orgId" element={<AdminOrgDetail productKey={productKey} accentColor={accentColor} />} />
        <Route path="codes" element={<AdminCodes productKey={productKey} accentColor={accentColor} />} />
        <Route path="admins" element={<AdminAdminUsers productKey={productKey} accentColor={accentColor} />} />
        <Route path="analytics" element={<AdminAnalytics productKey={productKey} accentColor={accentColor} />} />
        <Route path="audit-logs" element={<ProductAdminAuditLogs productKey={productKey} accentColor={accentColor} />} />
        {productKey === 'p150' && (
          <Route path="norms" element={<P150NormAdmin />} />
        )}
      </Route>
    </>
  );
};

export { createProductAdminRoutes };
